import {Component, OnInit} from '@angular/core';
import {I18NService} from '../../i18n/i18n.service';
import {MsgBoxService} from '../../shared/msg-box.service';
import {UserProfile} from 'auth-commons';
import {LoginService} from '../../shared/login.service';

@Component({
    selector: 'app-activate-totp',
    templateUrl: './activate-totp.component.html',
    styleUrls: ['./activate-totp.component.scss']
})
export class ActivateTotpComponent implements OnInit {

    constructor(private readonly loginService: LoginService,
                private readonly i18n: I18NService,
                private readonly msgBoxService: MsgBoxService) {
    }

    ngOnInit() {
    }

    onLogin(user: UserProfile) {
        this.loginService.notifyLogin(user);
    }

    onMsg(msg: string) {
        this.msgBoxService.info(msg, true);
    }

    onError(event: [string, Error]) {
        this.msgBoxService.error(event[0], event[1]);
    }
}
